import { render, staticRenderFns } from "./MainMenu.vue?vue&type=template&id=4ed18a3a&"
import script from "./MainMenu.vue?vue&type=script&lang=js&"
export * from "./MainMenu.vue?vue&type=script&lang=js&"
import style0 from "./MainMenu.vue?vue&type=style&index=0&id=4ed18a3a&prod&lang=scss&"
import style1 from "./MainMenu.vue?vue&type=style&index=1&id=4ed18a3a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports